import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class ReportWaste extends Component {
  render() {
    return (
      <div className="card p-0">
        {this.props.inventoriesList.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th title="Item name - brand - grade">Item Description</th>
                <th className="hidden-md-down" title="QuickBooksMapping identifier">Item Number</th>
                <th className="hidden-md-down">Station</th>
                <th className="hidden-md-down">Quantity</th>
                <th className="hidden-xs-down">Category</th>
                <th className="hidden-md-down">Packing Date</th>
                <th className="hidden-xs-down">Delete Date</th>
                <th className="hidden-md-down">User</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {this.props.inventoriesList.map((i,idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <NavLink to={`/inventory/${i.id}/`}>
                        {i.id}
                      </NavLink>
                    </td>
                    <td>{i.item}</td>
                    <td className="hidden-md-down">{i.item_number}</td>
                    <td className="hidden-md-down">{i.station}</td>
                    <td className="hidden-md-down">{i.quantity}</td>
                    <td className="hidden-xs-down">{i.waste_category}</td>
                    <td className="hidden-md-down">{i.packing_date}</td>
                    <td className="hidden-xs-down">{i.delete_date}</td>
                    <td className="hidden-md-down">{i.delete_user}</td>
                    <td>
                        <NavLink className="btn-sm btn-info" to={`/inventory/${i.id}/`}>
                            <i className="fa fa-eye"></i>
                        </NavLink>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for given filters
          </div>
        }
      </div>
    )
  }
}
